export default "__VITE_ASSET__DOJ4uVDF__"